import { useUser } from "../Components/UserProvider";
import { MenteePage } from "./Mentee/Mentee";
import { MentorPage } from "./Mentor/Mentor";

export default function Dashboard() {
	const user = useUser();
	
	if (user.mentor_profile) {
		return <MentorPage
			id={user.id}
		/>
	}
	
	return <MenteePage
		id={user.id}
	/>;
}
